import React from 'react';
import { color, font, space, weight } from '../theme';

// Desktop filter panels (Legislation, Committees): one labelled group per kind of filter,
// separated by a rule. Chips inside go full width or on an even Grid.
const FilterSection = ({ label, last, children }: { label: string; last?: boolean; children: React.ReactNode }) => (
  <div style={last ? undefined : { paddingBottom: space.md, marginBottom: space.md, borderBottom: `1px solid ${color.divider}` }}>
    <div style={{ fontSize: font.small, fontWeight: weight.bold, color: color.textSecondary, marginBottom: space.xs }}>{label}</div>
    <div style={{ display: 'flex', flexDirection: 'column' }}>{children}</div>
  </div>
);

export default FilterSection;
